<script>
import * as moment from 'moment'
import StockBalanceTable from '@/layerAdmin/components/StockBalanceTable.vue';
import StockBalanceChart from '@/layerAdmin/components/StockBalanceChart.vue';
import StockWeightsChart from '@/layerAdmin/components/StockWeightsChart.vue';

export default {
  components: {
    StockBalanceTable,
    StockBalanceChart,
    StockWeightsChart,
  },

  props: {
    batch: { type: Object, required: true },
  },

  data: function () {
    let numDaysInPast = 14;
    return {
      fromDate: moment().add(-numDaysInPast, 'days').format('YYYY-MM-DD'),
      toDate: moment().add(1, 'days').format('YYYY-MM-DD'),
    };
  },
}
</script>

<template>
  <div class="row">

    <div class="col-12 mb-3">
      <b-card>
        <h6 class="text-center mb-0">
          <div>Chicken Balances of <strong>{{batch.name}}</strong> </div>

          <div class="row my-2">
            <div class="col-6 offset-md-2 col-md-4">
              <b-form-input :id="`from-${_uid}`" v-model="fromDate" type="date" size="sm"></b-form-input>
            </div>
            <div class="col-6 col-md-4">
              <b-form-input :id="`to-${_uid}`" v-model="toDate" type="date" size="sm"></b-form-input>
            </div>
          </div>
        </h6>
      </b-card>

      <b-card class="mt-2">
        <stock-balance-table :batch="batch" :from-date="fromDate" :to-date="toDate" />
      </b-card>

      <b-card class="mt-2">
        <stock-balance-chart :batch="batch" :from-date="fromDate" :to-date="toDate" />
      </b-card>

      <b-card class="mt-2">
        <stock-weights-chart :batch="batch" :from-date="fromDate" :to-date="toDate" />
      </b-card>

    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AdminReportsPerBatch.vue